import { Link } from "react-router-dom";
import { FaTiktok, FaInstagram, FaYoutube } from "react-icons/fa";
import stjoseph from "../assets/stjoseph.jpg";
import bishoplogo from "../assets/bishop-logo.jpg";

const platformLinks = [
  { text: "St Mary's Junior Seminary Visiga", url: "/login" },
  { text: "Visiga / Morogoro-Road / Coast-Region" },
  { text: "P.O. Box 167   Dar-es-Salaam / Tanzania" },
  { text: "Phone: +255 767 927537" },
  { text: "Email" },
  { text: "st.mary_seminary@yahoo.com" },  
];

const socialLinks = [
  {
    icon: <FaTiktok size={22} />,
    url: "https://www.tiktok.com/@visigaseminary?_t=ZM-8yq9jAQpwRB&_r=1",
    label: "TikTok",
  },
  {
    icon: <FaInstagram size={22} />,
    url: "https://www.instagram.com/visigaseminary?igsh=MWhveWlxbGU1NWRoag==",
    label: "Instagram",
  },
  {
    icon: <FaYoutube size={22} />,
    url: "https://youtube.com/@visigaseminarytv?feature=shared",
    label: "YouTube",
  },
];

const Footer = () => {
  return (
    <footer className="mt-0 border-t py-4 border-neutral-700 dark:bg-gray-900 bg-[#85c4de]">
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center justify-center text-center md:text-left">
          {/* Left Side - Seminary Description */}
          <div className="flex flex-col md:flex-row items-center md:items-start space-y-2 md:space-y-0 md:space-x-4">
            <img
              src={stjoseph}
              alt="Cathedral"
              className="w-20 h-20 object-cover"
            />
            <h3 className="text-md font-semibold dark:text-white text-neutral-900">
              Seminary under Archdiocese of Dar es Salaam
            </h3>
          </div>

          {/* Center - Seminary Information */}
          <div className="flex flex-col items-center">
            <h3 className="text-sm font-semibold mb-1 dark:text-white text-neutral-900">
              Seminary Information
            </h3>
            <ul className="space-y-1 mt-2 text-center">
              {platformLinks.map((link, index) => (
                <li key={index}>
                  {link.url ? (
                    <Link
                      to={link.url}
                      className="text-xs dark:text-neutral-300 text-neutral-900 hover:text-white"
                    >
                      {link.text}
                    </Link>
                  ) : (
                    <span className="text-xs dark:text-neutral-300 text-neutral-900 cursor-default">
                      {link.text}
                    </span>
                  )}
                </li>
              ))}
            </ul>

            {/* Social Media Icons */}
            <div className="flex gap-4 mt-4 justify-center">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-900 dark:text-neutral-300 hover:text-blue-600 transition-colors"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Right Side - Archbishop */}
          <div className="flex flex-col md:flex-row items-center md:items-start space-y-2 md:space-y-0 md:space-x-4 justify-end">
            <img src={bishoplogo} alt="Archbishop" className="w-20 h-20 object-cover" />
            <h3 className="text-md font-semibold dark:text-white text-neutral-900 text-center md:text-left">
              Archbishop of the Archdiocese of Dar es Salaam.
            </h3>
          </div>
        </div>

        {/* Bottom - Rights Reserved */}
        <div className="mt-5 text-center">
          <p className="text-xs" style={{ color: "#3535de" }}>
            © {new Date().getFullYear()} All rights reserved by St Mary's Junior Seminary.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
